import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'phoneFormat',
	standalone: true,
})
export class PhoneFormatPipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) {
			return '';
		}

		let prefix = '';
		let number = '';

		// New format with separator: "+34|612345678"
		if (value.includes('|')) {
			[prefix, number] = value.split('|');
		} else if (value.startsWith('+34')) {
			prefix = '+34';
			number = value.slice(3);
		} else if (value.startsWith('+376')) {
			prefix = '+376';
			number = value.slice(4);
		} else {
			// Unknown format: return as-is
			return value;
		}

		// Clean number
		number = number.replace(/\D/g, '');

		// Format number: add space every 3 digits
		number = number.replace(/(\d{3})(?=\d)/g, '$1 ');

		return `${prefix} ${number}`;
	}
}
